<template>
  <public-page>
    <div class="about">
      <about-card />
      <testimonials-card />
      <credentials-card />
      <continuing-education-card />
      <contact-card />
    </div>
  </public-page>
</template>

<script>
import PublicPage from './PublicPage'
import AboutCard from '../cards/AboutCard'
import TestimonialsCard from '../cards/TestimonialsCard'
import CredentialsCard from '../cards/CredentialsCard'
import ContinuingEducationCard from '../cards/ContinuingEducationCard'
import ContactCard from '../cards/ContactCard'

const setOpenGraphMeta = require('./_helpers/openGraph.js')

export default {
  name: 'about',
  components: {
    PublicPage,
    AboutCard,
    TestimonialsCard,
    CredentialsCard,
    ContinuingEducationCard,
    ContactCard,
  },
  mounted () {
    setOpenGraphMeta({
      ogUrl: 'https://www.rewardingdogtraining.com/about',
      ogTitle: 'About - Rewarding Dog Training',
      ogDescription: 'Nadia Magallon, CSAT, CPDT-KA, is passionate about using technology to help people learn better and have a positively rewarding experience for both humans and dogs.',
    })
  },
}
</script>

<style lang="scss">
</style>
